import Vue from 'vue';
import Router from 'vue-router';
import Error from '../business/views/Error/Error.vue';
import Main from '../business/views/Main/Main.vue';
import ActiveForm from '../business/views/ActiveForm/ActiveForm.vue';
import ActiveCode from '../business/views/ActiveCode/ActiveCode.vue';
import UserRole from '../business/views/UserRole/UserRole.vue';
import { checkParams } from './Interceptor';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/v2',
      component: UserRole
    },
    {
      path: '/v2/InstallCode',
      component: Main
    },
    {
      path: '/v2/error',
      component: Error
    },
    {
      path: '/v2/ActiveForm',
      component: ActiveForm
    },
    {
      path: '/v2/ActiveCode',
      component: ActiveCode
    }
  ]
});

router.beforeEach((to, form, next) => {
  const completeParams = checkParams();
  if (!completeParams && to.path === '/v2') {
    next({ path: '/v2/error' });
  } else if (completeParams) {
    next();
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js